'use client';
import './styles/default.scss';
import { SvgLoader } from '@/app/elements/svg/loader';
import { useStore } from '@/store/store';

export const CloseButton = () => {
    const { closePopup } = useStore((state) => state.popup);

    return (
        <button className="close-button" onClick={closePopup}>
            <SvgLoader iconName="close" width="30" height="30" />
        </button>
    );
};
